import React, { useState } from 'react';
import { Box, Typography, Divider, Button, IconButton } from '@mui/material';
// import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import TestSelection from './test-selection.component';
import { useTestSearchContext } from '../contexts/test-search.context';
import { TEST_OPTIONS } from '../constants';
import TestCollection from './test-collection.component';
import LabTests from './labtests.component';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';
import Swal from 'sweetalert2';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Spinner from '../../../../components/spinner/spinner';
import { useLabTestStore } from '../labtest.store';
// import GoogleMapComponent from '../../../../components/googlemap/GoogleMap.component';

const TestTypeSelection = () => {
    const { setSearchStep, testType } = useTestSearchContext();
    const isValid = () => {
        if (testType === null) {
            return false;
        }
        return true;
    };
    const handleNext = () => {
        if (!isValid()) {
            return;
        }
        setSearchStep(1);
    };
    return (
        <Box className="labtest-option-container">
            <Box className="test-search-selections">
                <div className='space-between selection-title'>
                    <Typography variant="subtitle2">Choose Options</Typography>
                    {/* <div className='icon-wrapper grid-center'><CloseOutlinedIcon fontSize='small' /></div> */}
                </div>
                <Divider />
                <div className='selection-body'>
                    <TestSelection />
                </div>
                <Divider />
                <div className='selection-actions'>
                    <Button variant='contained' className='small-brown-btn' onClick={handleNext} disabled={!isValid()}>Next</Button>
                </div>
            </Box>
        </Box>
    );
};

const SearchTestBtn = () => {
    const { collectionType, selectedLocation, testDate, setSearchStep, setTests } = useTestSearchContext();
    const [loading, setLoading] = useState(false);
    const {validCity, validatingCity} = useLabTestStore();

    const isValid = () => {
        if (collectionType === null) {
            return false;
        }
        if (!selectedLocation) {
            return false;
        }
        if (!testDate) {
            return false;
        }
        // City Validation only happens when collection type is home collection
        if (collectionType === 0) {
            if (!validCity) {
                return false;
            }
            if (!validatingCity && !validCity) {
                return false;
            }
        }
        return true;
    };
    const searchTest = async () => {
        if (!isValid()) {
            return;
        }
        try {
            setLoading(true);
            const res = await httpClient.get(APIUtils.getAPIEndpoint('user-tests'));
            if (res.status === 200) {
                setTests(res.data.data);
                setSearchStep(2);
            }
        } catch (error) {
                console.log(error);
                Swal.fire('Something Went Wrong!', '', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Button variant='contained' className='small-brown-btn'>Searching...&nbsp;<Spinner /></Button>;
    }

    return <Button variant='contained' className='small-brown-btn' onClick={searchTest} disabled={!isValid()}>Search Test</Button>;
};

const TestCollectionType = () => {
    const { testType, setSearchStep } = useTestSearchContext();
    const handleBack = () => {
        setSearchStep(0);
    };
    return (
        <Box className="labtest-option-container">
            <Box className="test-search-selections">
                <div className='flex-gap selection-title'>
                    <IconButton aria-label="back" onClick={handleBack}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="subtitle2">
                        {TEST_OPTIONS[testType].name}
                    </Typography>
                    {/* <div className='icon-wrapper grid-center'><CloseOutlinedIcon fontSize='small' /></div> */}
                </div>
                <Divider />
                <div className='selection-body'>
                    <TestCollection />
                </div>
                <Divider />
                <div className='selection-actions'>
                    <SearchTestBtn />
                    {/* <Button variant='contained' className='small-brown-btn' onClick={handleBack}>Back</Button> */}
                </div>
            </Box>
        </Box>
    );
};

const LabTestContent = () => {
    const { searchStep } = useTestSearchContext();

    const labTestSearch = () => {
        switch (searchStep) {
            case 1:
                return <TestCollectionType />;
            case 2:
                return <LabTests />;

            default:
                return <TestTypeSelection />;
        }
    };

    return (
        <>{labTestSearch()}</>
    );
};

export default LabTestContent;